import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { BrandEditorData } from "../../state/Brands/EditorData";


const updateBrandsEditorData: Reducer<BrandEditorData> = (state: BrandEditorData = new BrandEditorData(), action: Action<ActionType, BrandEditorData>) => {
  switch (action.type) {
    case ActionType.BRANDS_EDITOR_DATA_RESET:
      return new BrandEditorData();
    case ActionType.BRANDS_EDITOR_DATA_FETCHED:
      return { ...state, brandData: action.data };
    case ActionType.BRANDS_EDITOR_DATA_COPIED:
      return { ...state, brandData: { ...action.data} };
    case ActionType.BRANDS_EDITOR_DATA_UPDATED:
      return { ...state, brandData: { ...state.brandData, ...action.data } };
    case ActionType.BRANDS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.BRANDS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateBrandsEditorData;